export type SidebarSectionName =
  | 'projects'
  | 'favorites'
  | 'routines'
  | 'recents';

export type SidebarSectionBoundaryRect = {
  bottom: number;
  section: SidebarSectionName;
};

export function findFirstVisibleSidebarSection({
  boundaryTop,
  boundaries,
}: {
  boundaryTop: number;
  boundaries: SidebarSectionBoundaryRect[];
}): SidebarSectionName | null {
  return boundaries.find(({ bottom }) => bottom > boundaryTop)?.section ?? null;
}

export function findSidebarSectionBoundaryIndexes<T>(
  items: readonly T[],
  getSection: (item: T) => SidebarSectionName
): number[] {
  const boundaryIndexBySection = new Map<SidebarSectionName, number>();

  items.forEach((item, index) => {
    boundaryIndexBySection.set(getSection(item), index);
  });

  return [...boundaryIndexBySection.values()];
}
